"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCardType = exports.CardType = void 0;
var CardType;
(function (CardType) {
    CardType["Credit"] = "credit";
    CardType["Debit"] = "debit";
    CardType["Prepaid"] = "prepaid";
    CardType["Unknown"] = "unknown";
})(CardType = exports.CardType || (exports.CardType = {}));
function toCardType(_cardType) {
    const cardType = _cardType.toLowerCase();
    switch (cardType) {
        case 'credit':
            return CardType.Credit;
        case 'debit':
            return CardType.Debit;
        case 'prepaid':
            return CardType.Prepaid;
        default:
            return CardType.Unknown;
    }
}
exports.toCardType = toCardType;
//# sourceMappingURL=cardType.js.map